import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import InputAdornment from "@mui/material/InputAdornment";
import { Icon } from "../../../Icon/index.js";
import { Box } from "../../../Box/index.js";
const ClearButton = (t0)=>{
    const $ = c(10);
    const { className: t1, color: t2, onClick, testId } = t0;
    const className = void 0 === t1 ? "" : t1;
    const color = void 0 === t2 ? "disabled" : t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            height: 0
        };
        $[0] = t3;
    } else t3 = $[0];
    const t4 = "disabled" === color ? "stroke.secondary" : "accent.text.error";
    let t5;
    if ($[1] !== t4) {
        t5 = /*#__PURE__*/ jsx(Icon, {
            name: "dismiss_substract",
            color: t4,
            size: "24"
        });
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] !== onClick || $[4] !== t5 || $[5] !== testId) {
        t6 = /*#__PURE__*/ jsx(Box, {
            onClick: onClick,
            testId: testId,
            children: t5
        });
        $[3] = onClick;
        $[4] = t5;
        $[5] = testId;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== className || $[8] !== t6) {
        t7 = /*#__PURE__*/ jsx(InputAdornment, {
            className: className,
            position: "end",
            sx: t3,
            children: t6
        });
        $[7] = className;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    return t7;
};
export { ClearButton };
